import { render, staticRenderFns } from "./SQuesSix.vue?vue&type=template&id=6cc664f4&"
import script from "./SQuesSix.vue?vue&type=script&lang=js&"
export * from "./SQuesSix.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports